import { InjectionToken } from '@angular/core';

type Measurement = ('BloodPressure' | 'BloodSugar' | 'BloodOxygen' | 'SpO2' | 'BMI' | 'Waist' | 'BodyFatPercentage' | 'HeartRate' | 'Ecg' | 'BodyTemperature' | 'TotalCholesterol' | 'UricAcid' | 'BloodDraw' | 'Ketone')[];

const DEFAULT_MEASUREMENTS: Measurement = [
  'BloodPressure',
  'BloodSugar',
  'BloodOxygen',
  'BMI',
  'Waist',
  'BodyFatPercentage',
  'HeartRate',
  'BodyTemperature',
  'TotalCholesterol',
  'UricAcid',
];

export const MEASUREMENT = new InjectionToken<Measurement>('MEASUREMENT', {
  providedIn: 'root',
  factory: () => DEFAULT_MEASUREMENTS,
});
